// extracted by mini-css-extract-plugin
export default {"editButton":"EditButton__editButton___kyWlT","user":"EditButton__user___A9sHk","child":"EditButton__child___dvK6i"};